// Transaction detail page (en).
window.PlummeI18n.register('en', {
  'transaction.annulBy': 'Annulled by',
  "transaction.annulAudit": "Annulment history",
  "transaction.annulledAt": "Annulled at",
  "transaction.annulReason": "Reason",
  "transaction.annulActor": "User ID",
  "transaction.reversalDate": "Reversal accounting date",
  "transaction.openOriginal": "Open original entry",
  "transaction.openReversal": "Open reversal",
  "transaction.auditMissing": "Not recorded",
  "transaction.reversalMissing": "The reversal is not available in the loaded journal.",
  "transaction.auditDebit": "Debit",
  "transaction.auditCredit": "Credit",

  'transaction.incompleteBasis': 'Journal coverage is incomplete. This voucher remains available for documentation and diagnostics; its totals must not be treated as complete.',
  'transaction.journalLoading': 'The accounting journal is loading. The voucher appears once it has been read.',
  'route.transaction': 'Transaction',
  'transaction.back': 'Back to all transactions',
  'transaction.title': 'Transaction',
  'transaction.posting': 'Entry',
  'transaction.summary': 'Summary – amounts into and out of accounts',
  'transaction.account': 'Account',
  'transaction.incoming': 'Into account',
  'transaction.outgoing': 'Out of account',
  'transaction.total': 'Total',
  'transaction.description': 'Description',
  'transaction.links': 'Linked records',
  'transaction.sourceLead': 'This is the posting for',
  'transaction.sourceHelp': 'Open the source to change the transaction or a related payment.',
  'transaction.relatedPayments': 'Related payments',
  'transaction.correctionReplacement': 'Replacement voucher',
  'transaction.correctionOriginal': 'Original voucher',
  'transaction.correctionReason': 'Correction reason',
  'transaction.created': 'Created',
  'transaction.by': 'by',
  'transaction.vatCodes': 'VAT codes',
  'transaction.accountNumber': 'Account no.',
  'transaction.name': 'Name',
  'transaction.amount': 'Amount',
  'transaction.documentation': 'Documentation',
  'transaction.generatedDocument': 'The invoice document is generated when you open or download it.',
  'transaction.noDocumentation': 'No documentation is attached to this transaction.',
  'transaction.open': 'Open entry',
  'transaction.locked': 'Locked entry',
  'transaction.annulled': 'Annulled',
  'transaction.fallbackType': 'Entry',
  'transaction.notFound': 'Transaction not found',
  'transaction.notFoundHelp': 'The transaction may have been annulled, belong to another financial year, or no longer be available.',
  'transaction.invoice': 'Invoice',
  'transaction.purchase': 'Purchase',
  'transaction.otherSale': 'Other sale',
  'transaction.customs': 'Customs declaration',
  'transaction.openDocument': 'View voucher',
  'transaction.download': 'Download',
  'transaction.upload': 'Upload attachment',
  'transaction.uploaded': 'Attachment uploaded.',
  'transaction.uploadFailed': 'Could not upload the attachment.',
  'transaction.documentFailed': 'Could not retrieve the voucher from the backend.',
  'transaction.previewFailed': 'Could not display the voucher.',
  'transaction.lost': 'Voucher missing',
  'transaction.lostPrompt': 'Explanation for the log (optional):',
  'transaction.lostSaved': 'The voucher has been marked as missing.',
  'transaction.lostFailed': 'Could not mark the voucher as missing.',
  'transaction.annul': 'Annul transaction',
  'transaction.annulQuestion': 'Annul transaction?',
  'transaction.creditQuestion': 'Credit invoice?',
  'transaction.credit': 'Credit',
  'transaction.annulling': 'Annulling...',
  'transaction.annulHelp': 'The transaction is annulled and retained in history, but excluded from the reporting basis.',
  'transaction.creditHelp': 'The invoice is credited with a credit note created as a draft for review before sending.',
  'transaction.creditDraft': 'A credit note draft was created. Review and send it from the invoice list.',
  'transaction.annulledSaved': 'The transaction was annulled.',
  'transaction.annulFailed': 'Could not annul the transaction.',
  'transaction.privateReimbursed': 'The private expense was reimbursed.',
  'transaction.privateReimburseFailed': 'Could not reimburse the private expense.',
  'transaction.reimbursePrivate': 'Reimburse private expense',
  'transaction.reimbursePrivateHelp': 'Posts the reimbursement from the selected company bank account against account 2060 without posting the cost or VAT again.',
  'transaction.paymentDate': 'Payment date',
  'transaction.bankAccount': 'Bank account',
  'transaction.goTo': 'Go to',
  'transaction.bank': 'Bank',
  'transaction.vat': 'VAT',
  'transaction.yearEnd': 'Year-end closing',
});
